// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const WorkingHoursFragmentDoc = `
    fragment workingHours on WorkingHours {
  weekDays
  opening
  closing
}
    `;